export interface MoveMarkupInteractionStorage {
  originX: number;
  originY: number;
  currentX: number;
  currentY: number;
  deltaX: number;
  deltaY: number;
}

class MoveMarkupInteraction {
  originX: number;

  originY: number;

  currentX: number;

  currentY: number;

  deltaX: number;

  deltaY: number;

  constructor(storage: MoveMarkupInteractionStorage) {
    this.originX = storage.originX;
    this.originY = storage.originY;
    this.currentX = storage.currentX;
    this.currentY = storage.currentY;
    this.deltaX = storage.deltaX;
    this.deltaY = storage.deltaY;
  }
}

export default MoveMarkupInteraction;
